<template>
  <div class="zone-legend">
    <div class="zone-cards">
      <div
        v-for="zone in zones"
        :key="zone.sortOrder"
        class="zone-card"
        :style="{ borderLeftColor: zone.color || fallbackColor(zone.sortOrder) }"
      >
        <div class="zone-text">
          <div class="zone-name black--text">{{ zoneLabel(zone) }}</div>
          <div class="zone-desc grey--text">{{ zoneDesc(zone) }}</div>
        </div>
        <div v-if="zone.percentage != null" class="zone-pct black--text">{{ zone.percentage }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
const FALLBACK_COLORS = ["#f88e52", "#fefebd", "#84ca66"];

export default {
  name: "ZoneLegend",
  props: {
    // [{ sortOrder, label, color, percentage, avgValue, minValue, maxValue }]
    zones: { type: Array, default: () => [] },
  },
  methods: {
    fallbackColor(sortOrder) {
      return FALLBACK_COLORS[sortOrder] || "#147c46";
    },
    // Localized label/description keyed by the zone's English name from the API
    // (e.g. "Moderate Productivity Zones"); fall back to the raw label.
    zoneLabel(zone) {
      const key = `reports.farmProductivity.zoneLabels.${zone.label}`;
      const localized = this.$t(key);
      return localized === key ? zone.label || "" : localized;
    },
    zoneDesc(zone) {
      const key = `reports.farmProductivity.zoneDesc.${zone.label}`;
      const localized = this.$t(key);
      return localized === key ? "" : localized;
    },
  },
};
</script>

<style scoped>
.zone-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.zone-card {
  flex: 1 1 240px;
  border: 1px solid #e8e8e8;
  border-left-width: 6px;
  border-radius: 6px;
  padding: 16px 18px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.zone-text {
  padding-right: 12px;
}
.zone-name {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 6px;
}
.zone-desc {
  font-size: 12px;
  line-height: 1.4;
}
.zone-pct {
  font-weight: bold;
  font-size: 26px;
  white-space: nowrap;
}
</style>
